import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'

/**
 * What to call a customer on a connector. A few of them let a customer through
 * without a company name, so fall back rather than showing an empty row.
 */
export const integrationCustomerName = (customer: {
  companyName?: DashboardApi20240730.GetIntegrationCustomersService.IntegrationCustomer['companyName']
}): string => customer.companyName?.trim() || 'Unnamed company'
